export default {
      id: "device_type-usage",
      viewBox: "0 0 22 19",
      url: __webpack_public_path__ + "img/icons.svg#device_type",
      toString: function () {
        return this.url;
      }
    }